module.exports = __webpack_public_path__ + "stylesheets/video-folder-item_d7e157f3e7090020247859001a63f873.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/folder/video-folder-item.less
// module id = Vc67
// module chunks = 154